import { DisplaySection } from "app/main/utils/uiUtils";
import { isRoleExternal } from "app/services/LoginService";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { openFormDialog } from "app/store/tools/formDialogSlice";
import Icon from "@material-ui/core/Icon";
import TruckPlanLoadScoutResults from "./TruckPlanLoadScoutResults";

function TruckPlanSearches({ data, previewMode = false, title = "Load Scout Results" }) {
	const isExternal = useMemo(() => isRoleExternal(), []);
	const dispatch = useDispatch();

	const hasActiveSearch = !!data?.plan?.lastLoadScoutResults?.searchId;

	const startMarketMonitor = () => {
		dispatch(
			openFormDialog({
				viewId: "AGENT_CONFIGURATION_VIEW",
				dataIds: {
					carrierId: data?.carrier?._id,
					truckId: data?.truck?._id,
					planId: data?.plan?._id,
					truckInfo: {
						truckId: data?.truck?.truck_id || data?.truck?._id,
						carrierName: data?.carrier?.carrier_company_name,
						currentLocation: data?.plan?.current_location,
						availableDate: data?.plan?.current_available_date,
					},
				},
			})
		);
	};

	const stopMarketMonitor = () => {
		dispatch(
			openFormDialog({
				viewId: "CONFIRM_DIALOG",
				mode: "DELETE",
				dataIds: {
					title: "Stop Agent",
					message: `Are you sure you want to stop the agent for this truck? The active search will be expired.`,
					confirmLabel: "Stop Agent",
					url: `api/search/requests/${data?.plan?.lastLoadScoutResults?.searchId}/force-expire`,
					listenEvent: "profileRevision",
				},
			})
		);
	};

	return (
		<div className="flex w-full flex-col">
			<DisplaySection
				title={title}
				classes={{ root: "mx-0 mt-0 mb-28", divider: "mb-4" }}
				actions={
					!isExternal
						? hasActiveSearch
							? [
									{
										label: "Stop Agent",
										onClick: () => stopMarketMonitor(),
										startIcon: <Icon className="text-20">stop</Icon>,
									},
							  ]
							: [
									{
										label: "Start Agent",
										onClick: () => startMarketMonitor(),
										startIcon: <Icon className="text-20">play_arrow</Icon>,
									},
							  ]
						: []
				}
			>
				<TruckPlanLoadScoutResults carrierId={data?.carrier?._id} truckId={data?.truck?._id} planId={data?.plan?._id} />
			</DisplaySection>
		</div>
	);
}

export default TruckPlanSearches;
